import React from 'react';
import SimulatorsViewerArrangement from '../components/SimulatorsComponents/FullPagesComponents/SimulatorsViewerArrangement';
import MenuToolsBarFP from '../components/SimulatorsComponents/FullPagesComponents/Services/MenuToolsBarFP';
import LaunchKeyboardFP from '../components/SimulatorsComponents/FullPagesComponents/Interaction/LaunchKeyboardFP';
import { iMessage } from '../utils/DictionaryManagementUtils';
//= ========================================================================

const Sim_A03_Menu = ({ globJSON, simPlatform, slideshowRefs }) => (
  <SimulatorsViewerArrangement>
    {simPlatform !== iMessage
      && (
      <LaunchKeyboardFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        slideshowRefs={slideshowRefs}
      />
      )}
    <MenuToolsBarFP
      globJSON={globJSON}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
      isMenu
    />
  </SimulatorsViewerArrangement>
);

export default Sim_A03_Menu;
